////////////////////////////////////////////
//
// Swiper Slider Functions
//
////////////////////////////////////////////

import Swiper from 'swiper/bundle';

// Home Slider
var myHomeSwiper = new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    spaceBetween: 15,

    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
});

// Portfolio Slider
var myPortfolioSwiper = new Swiper('.portfolio-slider', {
    speed: 800,
    slidesPerView: 3,
    spaceBetween: 15,
    loop: true,
    centeredSlides: true,
    grabCursor: true,
    effect: 'coverflow',

    preloadImages: true,
    lazy: {
        loadPrevNext: true,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
